import { cva } from "class-variance-authority"

export const buttonVariants = cva(
  "inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-control ring-offset-background transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        // The border follows the fill on hover: a white border on a white
        // card vanishes and the button reads as shrinking.
        default:
          "bg-transparent border border-black hover:border-primary hover:bg-primary text-black hover:text-primary-foreground",
        // The inverse of `default`, sharing its hover: the page's one
        // primary action, and nothing else on the page.
        solid:
          "bg-foreground text-background hover:bg-primary hover:text-primary-foreground",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        "destructive-outline":
          "border border-destructive bg-background text-destructive hover:bg-destructive/10 ",
        outline:
          "rounded-md border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-black underline-offset-4 hover:underline",
        "link-destructive":
          "text-destructive underline-offset-4 hover:underline",
        "outline-link":
          "border border-input bg-background hover:bg-primary/10 hover:text-primary/90 text-primary underline-offset-4 hover:underline justify-start",
        accent: "bg-brand-light-sagecool-blue hover:bg-brand-sagecool-blue",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-full px-3",
        lg: "h-11 rounded-full px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
)
